import DynamicElementPositionHelper from '../../../helpers/DynamicElementPositionHelper';
import WindowSizeHelper from '../../../helpers/WindowSizeHelper';
import { StylePositionType } from '../../../styles/enums';

export default class TooltipPositionHelper {
  static getPosition(tooltip, activator, { yPosition } = {}) {
    const { height, width } = tooltip.getBoundingClientRect();
    const activatorRect = activator.getBoundingClientRect();

    return {
      ...this.#getHorizontalPosition(width, activatorRect),
      ...this.#getVerticalPosition(height, activatorRect, yPosition),
    };
  }

  static getArrowHorizontalPosition(tooltipPosition, activator) {
    const { width, x } = activator.getBoundingClientRect();
    const { left } = tooltipPosition;

    return left
      ? { left: -left + width / 2 }
      : { right: WindowSizeHelper.getClientWidth() - x - width / 2 };
  }

  static #getVerticalPosition(height, activatorRect, yPosition) {
    const { top: activatorY, height: activatorHeight } = activatorRect;
    const relativeTopPosition = -height;
    const absoluteTopPosition = activatorY + relativeTopPosition;

    if (absoluteTopPosition < 0) {
      return { top: activatorHeight };
    }

    return yPosition === StylePositionType.Bottom
      ? { top: activatorHeight }
      : { bottom: activatorHeight };
  }

  static #getHorizontalPosition(width, activatorRect) {
    const { left: activatorX, width: activatorWidth } = activatorRect;
    const relativeCenteredLeftPosition = -(width / 2) + activatorWidth / 2;
    const absoluteCenteredLeftPosition = activatorX + relativeCenteredLeftPosition;
    const isCenteredPositionValid = absoluteCenteredLeftPosition > 0
      && DynamicElementPositionHelper.isInViewportX(absoluteCenteredLeftPosition, width);

    return isCenteredPositionValid
      ? { left: relativeCenteredLeftPosition }
      : this.#getEdgeHorizontalPosition(activatorX, activatorWidth);
  }

  static #getEdgeHorizontalPosition(activatorX, activatorWidth) {
    return this.#isNearLeftBorder(activatorX)
      ? { left: -activatorX }
      : { right: activatorX + activatorWidth - WindowSizeHelper.getClientWidth() };
  }

  static #isNearLeftBorder(activatorX) {
    return activatorX < WindowSizeHelper.getClientWidth() / 2;
  }
}
